/** Tokens visuais — Configurações da Clínica Klinvia (frontend-design + agendaTheme) */
import { AGENDA_THEME } from '../../pages/agendaTheme';

export const CLINIC_SETTINGS_THEME = {
  ...AGENDA_THEME,
  sectionTitle: AGENDA_THEME.navy,
  subtitle: AGENDA_THEME.slate,
  caption: AGENDA_THEME.slate,
  captionFaint: AGENDA_THEME.slateFaint,
  subsectionTitle: '#334155',
  unitChipBg: AGENDA_THEME.tealSoft,
  unitChipText: AGENDA_THEME.tealDark,
  refreshBg: 'rgba(13, 148, 136, 0.1)',
  refreshBgHover: 'rgba(13, 148, 136, 0.18)',
  proChipBg: AGENDA_THEME.tealSoft,
  proChipText: AGENDA_THEME.tealDark,
  letterheadActiveBg: AGENDA_THEME.muted,
  letterheadInactiveBg: '#FFFBEB',
  letterheadInactiveBorder: '#FCD34D',
  nfseEnabledBg: '#ECFDF5',
  nfseEnabledText: '#166534',
  nfseDisabledBg: '#FEF2F2',
  nfseDisabledText: '#B91C1C',
  silencePanelBg: AGENDA_THEME.muted,
  silencePanelBorder: AGENDA_THEME.borderSoft,
  logoPlaceholder: AGENDA_THEME.slateFaint,
} as const;

export const clinicSettingsClinicalGridBg = {
  backgroundColor: CLINIC_SETTINGS_THEME.muted,
  backgroundImage: `
    linear-gradient(${CLINIC_SETTINGS_THEME.gridLine} 1px, transparent 1px),
    linear-gradient(90deg, ${CLINIC_SETTINGS_THEME.gridLine} 1px, transparent 1px)
  `,
  backgroundSize: '24px 24px',
};

export const clinicSettingsPageShellSx = {
  ...clinicSettingsClinicalGridBg,
  borderRadius: 2,
  px: { xs: 0.5, sm: 1 },
  py: { xs: 1, sm: 1.5 },
};

export const clinicSettingsHeaderSx = {
  mb: 3,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: { xs: 'flex-start', md: 'center' },
  flexDirection: { xs: 'column', md: 'row' },
  gap: 2,
  p: { xs: 1.5, sm: 2 },
  borderRadius: 2,
  border: `1px solid ${CLINIC_SETTINGS_THEME.borderSoft}`,
  bgcolor: CLINIC_SETTINGS_THEME.paper,
  boxShadow: CLINIC_SETTINGS_THEME.shadow,
};

export const clinicSettingsSubtitleSx = {
  color: CLINIC_SETTINGS_THEME.subtitle,
  fontSize: { xs: '0.75rem', md: '0.875rem' },
};

export const clinicSettingsUnitChipSx = {
  mt: 1,
  bgcolor: CLINIC_SETTINGS_THEME.unitChipBg,
  color: CLINIC_SETTINGS_THEME.unitChipText,
  fontWeight: 600,
  border: `1px solid ${CLINIC_SETTINGS_THEME.border}`,
};

export const clinicSettingsRefreshButtonSx = {
  bgcolor: CLINIC_SETTINGS_THEME.refreshBg,
  color: CLINIC_SETTINGS_THEME.tealDark,
  '&:hover': { bgcolor: CLINIC_SETTINGS_THEME.refreshBgHover },
};

export const clinicSettingsPrimaryButtonSx = {
  bgcolor: CLINIC_SETTINGS_THEME.teal,
  '&:hover': { bgcolor: CLINIC_SETTINGS_THEME.tealDark },
  borderRadius: 2,
  textTransform: 'none' as const,
  fontWeight: 600,
};

export const clinicSettingsOutlinedButtonSx = {
  textTransform: 'none' as const,
  borderColor: CLINIC_SETTINGS_THEME.teal,
  color: CLINIC_SETTINGS_THEME.tealDark,
  '&:hover': {
    borderColor: CLINIC_SETTINGS_THEME.tealDark,
    bgcolor: CLINIC_SETTINGS_THEME.tealSoft,
  },
};

export const clinicSettingsSectionCardSx = {
  borderRadius: 3,
  border: `1px solid ${CLINIC_SETTINGS_THEME.borderSoft}`,
  boxShadow: CLINIC_SETTINGS_THEME.shadow,
  bgcolor: CLINIC_SETTINGS_THEME.paper,
  height: '100%',
};

export const clinicSettingsSectionCardFlatSx = {
  borderRadius: 3,
  border: `1px solid ${CLINIC_SETTINGS_THEME.borderSoft}`,
  boxShadow: CLINIC_SETTINGS_THEME.shadow,
  bgcolor: CLINIC_SETTINGS_THEME.paper,
};

export const clinicSettingsSectionHeaderSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  mb: 2,
};

export const clinicSettingsSectionHeaderWrapSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  mb: 2,
  flexWrap: 'wrap' as const,
};

export const clinicSettingsSectionIconSx = {
  color: CLINIC_SETTINGS_THEME.teal,
};

export const clinicSettingsSectionTitleSx = {
  fontWeight: 700,
  color: CLINIC_SETTINGS_THEME.sectionTitle,
  letterSpacing: '-0.01em',
};

export const clinicSettingsCaptionSx = {
  color: CLINIC_SETTINGS_THEME.caption,
};

export const clinicSettingsCaptionBlockSx = {
  color: CLINIC_SETTINGS_THEME.caption,
  display: 'block',
};

export const clinicSettingsCaptionFaintBlockSx = {
  color: CLINIC_SETTINGS_THEME.captionFaint,
  display: 'block',
};

export const clinicSettingsSubsectionTitleSx = {
  fontWeight: 700,
  color: CLINIC_SETTINGS_THEME.subsectionTitle,
};

export const clinicSettingsSwitchSx = {
  '& .MuiSwitch-switchBase.Mui-checked': { color: CLINIC_SETTINGS_THEME.teal },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: CLINIC_SETTINGS_THEME.teal,
  },
};

export const clinicSettingsInfoAlertSx = {
  mb: 3,
  borderRadius: 2,
  border: `1px solid ${CLINIC_SETTINGS_THEME.border}`,
  bgcolor: CLINIC_SETTINGS_THEME.tealSoft,
};

export const clinicSettingsLoadingSx = {
  display: 'flex',
  flexDirection: 'column' as const,
  gap: 2,
  py: 4,
  px: { xs: 1, sm: 2 },
};

export const clinicSettingsProChipSx = {
  bgcolor: CLINIC_SETTINGS_THEME.proChipBg,
  color: CLINIC_SETTINGS_THEME.proChipText,
  fontWeight: 600,
};

export const clinicSettingsLogoLabelSx = {
  fontWeight: 600,
  mb: 1,
  color: CLINIC_SETTINGS_THEME.subsectionTitle,
};

export const clinicSettingsSilencePanelSx = {
  p: 2,
  borderRadius: 2,
  bgcolor: CLINIC_SETTINGS_THEME.silencePanelBg,
  border: `1px solid ${CLINIC_SETTINGS_THEME.silencePanelBorder}`,
};

export const clinicSettingsFooterActionsSx = {
  mt: 3,
  textAlign: 'right' as const,
  pt: 2,
  borderTop: `1px solid ${CLINIC_SETTINGS_THEME.borderSoft}`,
};

export const clinicSettingsLetterheadToggleBoxSx = (enabled: boolean) => ({
  mb: 2,
  p: 1.5,
  borderRadius: 2,
  bgcolor: enabled ? CLINIC_SETTINGS_THEME.letterheadActiveBg : CLINIC_SETTINGS_THEME.letterheadInactiveBg,
  border: '1px solid',
  borderColor: enabled ? CLINIC_SETTINGS_THEME.borderSoft : CLINIC_SETTINGS_THEME.letterheadInactiveBorder,
});

export const clinicSettingsNfseStatusChipSx = (enabled: boolean) => ({
  ml: 1,
  bgcolor: enabled ? CLINIC_SETTINGS_THEME.nfseEnabledBg : CLINIC_SETTINGS_THEME.nfseDisabledBg,
  color: enabled ? CLINIC_SETTINGS_THEME.nfseEnabledText : CLINIC_SETTINGS_THEME.nfseDisabledText,
  fontWeight: 600,
});

export const clinicSettingsNfseNationalChipSx = (active: boolean) => ({
  ml: 1,
  bgcolor: active ? CLINIC_SETTINGS_THEME.tealSoft : CLINIC_SETTINGS_THEME.mutedAlt,
  color: active ? CLINIC_SETTINGS_THEME.tealDark : CLINIC_SETTINGS_THEME.slate,
  fontWeight: 600,
});
